export const projects = [
    {
        name: 'Horror Game Demo',
        date: 'Dec 2020 - Jan 2021',
        description: 'A First Person story based horror game set inside a single house. Taking an Edith Finch approach to gameplay ,narrative and design. Made with Unity.',
        github: 'https://github.com/mln-grg/Untitled-Horror-Game',
        youtube: 'https://www.youtube.com/embed/Z8LycaXvo9s',
        pic: 'projectpictures/horrorgame.png',
    },
    {
        name: 'Cartino',
        date: 'Oct 2020 - Dec 2020',
        description: 'A 3D Bullet Hell game made using a combination of different design patterns including Singleton, Observer, Object Pooling, and Finite State Machines. The build platform of choice was Android and Editor used was Unity.',
        github: 'https://github.com/mln-grg/Cartino',
        youtube: 'https://www.youtube.com/embed/1K5QdXoQiUA',
        pic: 'projectpictures/cartino.png',
    },
    {
        name: 'Simple Unity 2D Platformer',
        date: 'Sep 2020 - Oct 2020',
        description: 'A simple Tower Defense 2D game, that involves placing defenses to obstruct enemies from reaching their objective. Includes Basic pathfinding for enemies and Tilemaps used for level design. Made with Unity.',
        github: 'https://github.com/mln-grg/OutscalBasicsUnity',
        pic: 'projectpictures/2dplatformer.png',
    }
]